import React from "react";
import { CameraOff } from "lucide-react";
import SetupProgress from "./SetupProgress";
import WizardBackButton from "./WizardBackButton";
import WizardPrimaryButton from "./WizardPrimaryButton";

// One instruction slide (PHASES.SETUP); camera is only touched on the last step's Continue tap.
const InstructionSlide = ({
  step,
  index,
  total,
  canGoBack,
  onBack,
  onContinue,
  continueLoading,
  error,
  permissionDenied,
}) => {
  const Icon = step.icon;

  return (
    <div className="flex flex-col bg-gray-900 text-white h-screen" style={{ height: "100dvh" }}>
      <div
        className="flex-1 overflow-y-auto px-5 py-8 flex flex-col items-center justify-center text-center"
        style={{ overscrollBehavior: "contain", paddingTop: "calc(2rem + env(safe-area-inset-top))" }}
      >
        <div className="w-full max-w-sm">
          <div className="mb-6">
            <SetupProgress current={index} total={total} />
          </div>

          {permissionDenied ? (
            <>
              <div className="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-5 bg-red-500/20">
                <CameraOff className="w-8 h-8 text-red-400" />
              </div>
              <h1 className="text-xl font-semibold mb-2 text-red-400">Camera Permission Required</h1>
              <p className="text-gray-300 text-sm leading-relaxed">
                Camera permission was denied. Please allow camera access in your browser settings,
                then try again.
              </p>
            </>
          ) : (
            <>
              <div className="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-5 bg-gradient-to-br from-pink-500/20 to-blue-500/20 border border-pink-500/20">
                <Icon className="w-8 h-8 text-pink-300" />
              </div>
              <h1 className="text-xl font-semibold mb-2">{step.title}</h1>
              <p className="text-gray-300 text-sm leading-relaxed">{step.body}</p>
            </>
          )}

          {error && !permissionDenied && (
            <div className="mt-4 p-3 bg-red-900/30 border border-red-500/50 rounded-lg">
              <p className="text-red-300 text-sm">{error}</p>
            </div>
          )}
        </div>
      </div>

      <div className="flex gap-3 px-5 pt-3" style={{ paddingBottom: "calc(1rem + env(safe-area-inset-bottom))" }}>
        {canGoBack && <WizardBackButton onClick={onBack} disabled={continueLoading} />}
        <WizardPrimaryButton onClick={onContinue} disabled={continueLoading} busy={continueLoading}>
          {continueLoading ? "Starting…" : permissionDenied ? "Try Again" : "Continue"}
        </WizardPrimaryButton>
      </div>
    </div>
  );
};

export default InstructionSlide;
